import RemovableCompany from "./RemovableCompany";

const RemovablePromoter = RemovableCompany

export default RemovablePromoter;